import React, { createContext, useContext, useReducer } from 'react';
import { usersReducer } from '../reducer/usersReducer';

const UsersContext = createContext(undefined);

export const UsersProvider = ({ children }) => {
  const [state, dispatch] = useReducer(usersReducer, {});

  const setUser = (user) => {
    return dispatch({ type: 'SET', payload: user });
  };

  const getUser = () => {
    return dispatch({ type: 'GET' });
  };

  const getRole = (code) => {
    const codes = Array.isArray(code) ? code : [code];

    const result = {};

    codes.forEach((c) => {
      const roleList = state?.roleLists?.find((role) => role.code === c);
      const rolePermission = roleList?.roleListPermission?.[0];

      if (rolePermission) {
        result[c] = rolePermission.value !== null ? rolePermission.value : true;
      } else {
        result[c] = false;
      }
    });

    return result;
  };

  const setFavouriteMenu = (menu) => {
    return dispatch({ type: 'SET_FAVOURITE_MENU', payload: menu });
  };

  const updateFavouriteMenu = (menu) => {
    dispatch({ type: 'UPDATE_FAVOURITE_MENU', payload: menu });
  };

  const deleteFavouriteMenu = (id) => {
    dispatch({ type: 'DELETE_FAVOURITE_MENU', payload: id });
  };

  const updateViews = (views) => {
    dispatch({ type: 'UPDATE_VIEWS', payload: views });
  };

  const value = {
    user: state,
    setUser,
    getUser,
    updateViews,
    getRole,
    updateFavouriteMenu,
    deleteFavouriteMenu,
    setFavouriteMenu,
  };

  return <UsersContext.Provider value={value}>{children}</UsersContext.Provider>;
};

const useUsers = () => {
  return useContext(UsersContext);
};

export default useUsers;
